


































import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseAvatar from '../base-avatar/_base-avatar.vue';
import { AvatarSize } from './enums/avatar-size';
@Component({
  name: 'BaseAvatarGroup',
  components: {
    BaseAvatar,
  },
})
export default class BaseAvatarGroup extends Vue {
  @Prop() avatars: { name?: string; thumbUrl?: string }[];
  @Prop({ default: 2 }) visibleAvatars: number;
  @Prop({ default: 6 }) margin: number;
  @Prop({ default: AvatarSize.Medium }) size: AvatarSize;
  @Prop() clickable?: boolean;

  get displayedAvatars(): number {
    return this.avatars.length <= this.visibleAvatars + 1
      ? this.avatars.length
      : this.visibleAvatars;
  }

  get componentTag(): string {
    return this.clickable ? 'button' : 'div';
  }

  get marginStyle(): string {
    return `margin-left: -${this.margin}px`;
  }
}
